import type { ShareIntent } from 'expo-share-intent';

/**
 * Веб-заглушка системного «Поделиться» (стори 8.7).
 *
 * <p>Приёмник содержимого — это расширение операционной системы (Share Extension на iOS,
 * intent-filter на Android). У страницы в браузере такого места нет: система показывает список
 * приложений, а не вкладок. Поэтому в вебе хук всегда отвечает «ничего не приходило», и весь
 * дальнейший код — буфер, лист выбора чата, отправка — просто не запускается.
 *
 * <p>Заглушка нужна ещё и потому, что настоящий пакет тянет `expo-modules-core`: сборка вебпака
 * на нём спотыкается ровно так же, как на `expo-haptics` (см. `webpack.config.cjs`).
 */

const EMPTY: ShareIntent = { files: null, meta: null, text: null, type: null, webUrl: null };

export function useShareIntent(): {
  isReady: boolean;
  hasShareIntent: boolean;
  shareIntent: ShareIntent;
  resetShareIntent: (clearNativeModule?: boolean) => void;
  error: string | null;
} {
  return {
    isReady: true,
    hasShareIntent: false,
    shareIntent: EMPTY,
    resetShareIntent: () => {},
    error: null,
  };
}

export default useShareIntent;
